import React, { useEffect, useState } from 'react'
import { appConfig, themeConfig } from 'config'
// import { Switch, Route, withRouter, Redirect } from 'react-router-dom'
import { Routes, Route, Link, Navigate, useLocation, redirect } from 'react-router-dom'
import {
  Login,
  ResetPassword,
  VerifyPassword,
  RegisterNewAccount,
  PageNotFound,
  MyMerchant,
  HilightBanner,
  Coupon,
  Merchants,
  Uom,
  Manufactuer,
  Categories,
  Product,
  ProductRequest,
  MerchantProfile,
  DeliveryCost,
  Orders,
  Dashboard,
  Pos,
  PosPackages,
  PosRegister,
  PaymentConfig,
  PosMornitoring,
  Advertise,
  ManageUser,
  Welcome,
  PermissionDenied,
  Suppliers,
  Purchase,
  Pickup,
  GRN,
  PurchaseSetting,
  Stock,
  TaxManagement,
  PointManagement,

  //b2b
  Quotation,
  SupplierOrder,
  SupplierInvoice,
  Customers,
  SupplierBill,

  //rmx
  DashboardRmx,
  DashboardRmxOverall,

  //report
  Reports,

  //return
  OrderReturns,

  //permission
  Permissions,
  ManageContents,
  DocumentConfig,

  //crm
  PointConfig,
  PointMember,
  PointMemberReward,
  PointMemberRedeem,
  StockConfig,
} from 'Pages'
import { getAccessToken, getActiveMerchant, getStaffPermission, getUserLogin } from 'helpers/account'
import { updateCurrentUserAction, updateActiveMerchantAction } from 'Store/user/actions'
import { selectCurrentUser } from 'Store/user/selector'
import { connect, useDispatch } from 'react-redux'
import RootState from 'typings/RootState'
import { countNewOrderAPI } from 'Store/orders/api'
import { checkMerchantPackagesAPI, getConfigListAPI, getMerchantPackageListAPI } from 'Store/pos/api'
import { getConfigAPI } from 'Store/config/api'
import { MerchantPackageListReq } from 'Store/pos/types'
import 'assets/styles/antd-customized.css'
import 'assets/styles/App.css'
import { DocumentConfigKey } from 'helpers/constanst'
import { refreshTokenAPI } from 'Store/user/api'
import { getCountMinimumStockAPI } from 'Store/stock/api'
// import { Redirect } from 'react-router-dom'

type AppProps = {}
type Props = ReduxProps & DispatchProps & AppProps

const App: React.FunctionComponent<Props> = props => {
  const { currentUser } = props
  //let location = useLocation()
  const pathName = window.location.pathname
  //const pathName = 'test' as string
  const dispatch = useDispatch()
  const userInfo = getUserLogin()
  const isMerchant = userInfo && userInfo?.store_type === 'merchant'
  const isSupperAdmin = currentUser?.activeMerchant?.id === parseInt(appConfig.merchantID || '')
  const [permission, setPermission] = useState<string[]>([])
  const isMock = false
  const hasConfigDocument = permission && permission?.includes('/document-config')

  const setFont = (font: string) => {
    document.documentElement.style.setProperty('--font', font)
  }

  const setHeaderStyle = () => {
    const link = document.querySelector("link[rel~='icon']")
    const linkAppIcon = document.querySelector("link[rel~='apple-touch-icon']")
    const metaColor = document?.getElementById('meta_theme_color')
    const metaDescription = document?.getElementById('meta_description')
    const metaAppName = document?.getElementById('meta_app_name')
    const metaMobileAppName = document?.getElementById('meta_mobile_app_name')
    const color = themeConfig.colors.primary
    const title = themeConfig.title.fullName
    const icon = themeConfig.title.webIcon
    const appIcon = themeConfig.title.appIcon
    const appName = themeConfig.title.appName
    metaColor && metaColor.setAttribute('content', color)
    metaDescription && metaDescription.setAttribute('content', title)
    metaAppName && metaAppName.setAttribute('content', title)
    metaMobileAppName && metaMobileAppName.setAttribute('content', appName)
    link && link.setAttribute('href', icon)
    linkAppIcon && linkAppIcon.setAttribute('href', appIcon)
    document.title = title
    const primaryColor = document?.documentElement?.style?.setProperty('@primary-color', color)
  }

  useEffect(() => {
    const permission = getStaffPermission()
    if (permission) {
      setPermission([...permission])
    } else {
      setPermission([])
    }
  }, [])

  useEffect(() => {
    const permission = getStaffPermission()
    if (permission) {
      setPermission([...permission])
    } else {
      setPermission([])
    }
  }, [pathName])

  useEffect(() => {
    setFont(themeConfig.fontFamily.primary)
    setHeaderStyle()
  }, [])

  const countNewOrder = (): void => {
    dispatch(countNewOrderAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const countStockNotice = () => {
    dispatch(getCountMinimumStockAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetConfig = () => {
    dispatch(getConfigAPI({}, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onRefreshToken = () => {
    dispatch(
      refreshTokenAPI(
        {
          refresh_token: userInfo?.refresh_token || '',
          client_id: 'test',
          client_secret: 'test',
          grant_type: 'refresh_token',
        },
        currentUser.accessToken,
      ),
    )
  }

  const onGetConfigList = () => {
    dispatch(
      getConfigListAPI(
        {
          config: `${DocumentConfigKey.TAX},${DocumentConfigKey.QUOTATION},${DocumentConfigKey.DELIVERY},${DocumentConfigKey.COMMON},${DocumentConfigKey.VAT_TYPE},${DocumentConfigKey.BARCODE}`,
        },
        currentUser.accessToken,
        currentUser?.activeMerchant?.uuid || '',
      ),
    )
  }

  const onGetMerchantPackageList = (): void => {
    const req: MerchantPackageListReq = {}
    dispatch(getMerchantPackageListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const checkMerchantPackage = (): void => {
    dispatch(
      checkMerchantPackagesAPI(
        {
          merchant_id: currentUser?.activeMerchant?.id || 0,
          status: 'active',
          has_package: true,
        },
        currentUser.accessToken,
      ),
    )
  }

  useEffect(() => {
    const token = getAccessToken()
    const activeMerchant = getActiveMerchant()
    dispatch(updateCurrentUserAction({ accessToken: token }))
    if (activeMerchant) {
      dispatch(updateActiveMerchantAction({ merchant: activeMerchant }))
    }
  }, [pathName])

  useEffect(() => {
    if (currentUser.accessToken && currentUser?.activeMerchant?.uuid) {
      countNewOrder()
      countStockNotice()
      checkMerchantPackage()
      onGetConfig()
      if (isMerchant) {
        onRefreshToken()
      }
    }
  }, [currentUser?.activeMerchant?.uuid])

  useEffect(() => {
    if (currentUser.accessToken && currentUser?.activeMerchant?.uuid) {
      if (hasConfigDocument) {
        onGetConfigList()
      }
    }
  }, [currentUser?.activeMerchant?.uuid, hasConfigDocument])

  useEffect(() => {
    if (currentUser.accessToken && currentUser?.activeMerchant?.uuid) {
      if (permission && permission?.includes('/pos')) {
        onGetMerchantPackageList()
      }
    }
  }, [currentUser?.activeMerchant?.uuid, permission])

  const isNotLogin = !currentUser || currentUser.accessToken === ''
  const isNotActive = !currentUser || !currentUser.activeMerchant

  if (isNotLogin) {
    return (
      <Routes>
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="/reset/:token" element={<VerifyPassword />} />
        <Route path="/new/:token" element={<RegisterNewAccount />} />
        <Route path="*" element={<Login />} />
      </Routes>
      // <Switch>
      //   <Route      path="/reset" element={ResetPassword} />
      //   <Route      path="/reset/:token" element={VerifyPassword} />
      //   <Route      path="/new/:token" element={RegisterNewAccount} />
      //   <Route element={Login} />
      // </Switch>
    )
  } else {
    if (pathName === '/login' || pathName === '/reset' || pathName === '/new') {
      return (
        <Routes>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/reset" element={<Navigate to="/" replace />} />
          <Route path="/new" element={<Navigate to="/" replace />} />
        </Routes>
      )
    }
  }

  const getMerchantRoute = () => {
    return (
      <Routes>
        <Route path="/" element={isNotActive ? <MyMerchant /> : <Dashboard />} />
        {/* no reqyire permissio  */}
        <Route path="/mymerchants" element={<MyMerchant />} />
        <Route path="/manage-user" element={<ManageUser />} />

        {/* for  pathName.includes('/pos/') */}
        <Route path="/pos" element={<Pos />} />
        <Route path="/pos/packages" element={<PosPackages />} />
        <Route path="/pos/packages/:id" element={<PosRegister />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/banners" element={<HilightBanner />} />
        <Route path="/coupons" element={<Coupon />} />
        <Route path="/merchants" element={<Merchants />} />
        <Route path="/merchant-profile" element={<MerchantProfile />} />
        <Route path="/uoms" element={<Uom />} />
        <Route path="/manufacturers" element={<Manufactuer />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/products" element={<Product />} />
        <Route path="/products-request" element={<ProductRequest />} />
        <Route path="/delivery-costs" element={<DeliveryCost />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/new/:token" element={<RegisterNewAccount />} />
        <Route path="/pos" element={<Pos />} />
        <Route path="/pos/packages" element={<PosPackages />} />
        <Route path="/pos/packages/:id" element={<PosRegister />} />
        <Route path="/pos-mornitoring" element={<PosMornitoring />} />
        <Route path="/ads" element={<Advertise />} />
        <Route path="/manage-user" element={<ManageUser />} />
        <Route path="/supplier" element={<Suppliers />} />
        <Route path="/purchase" element={<Purchase />} />
        <Route path="/pick-up" element={<Pickup />} />
        <Route path="/grn" element={<GRN />} />
        <Route path="/purchase-setting" element={<PurchaseSetting />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/quotation" element={<Quotation />} />
        <Route path="/point" element={<PointManagement />} />
        <Route path="/tax" element={<TaxManagement />} />
        <Route path="/supplier-order" element={<SupplierOrder />} />
        <Route path="/supplier-invoice" element={<SupplierInvoice />} />
        <Route path="/supplier-billing-note" element={<SupplierBill />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/dashboard-rmx" element={<DashboardRmx />} />
        <Route path="/dashboard-rmx-overall" element={<DashboardRmxOverall />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/order-returns" element={<OrderReturns />} />
        <Route path="/manage-permission" element={<Permissions />} />
        <Route path="/contents" element={<ManageContents />} />
        <Route path="/document-config" element={<DocumentConfig />} />
        <Route path="/point-config" element={<PointConfig />} />
        <Route path="/point-member" element={<PointMember />} />
        <Route path="/point-reward" element={<PointMemberReward />} />
        <Route path="/point-redeem" element={<PointMemberRedeem />} />
        <Route path="/stock-config" element={<StockConfig />} />
        <Route path="/pos-payment-config" element={<PaymentConfig />} />
        <Route path="/permission-denined" element={<PermissionDenied />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    )
  }

  const getStaffRoute = () => {
    const permission = getStaffPermission()
    return (
      <Routes>
        <Route path="/" element={isNotActive ? <MyMerchant /> : <Welcome />} />
        <Route path="/pos" element={<Pos />} />
        <Route path="/pos/packages" element={<PosPackages />} />
        <Route path="/pos/packages/:id" element={<PosRegister />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/mymerchants" element={<MyMerchant />} />
        <Route path="/banners" element={<HilightBanner />} />
        <Route path="/coupons" element={<Coupon />} />
        <Route path="/merchants" element={<Merchants />} />
        <Route path="/merchant-profile" element={<MerchantProfile />} />
        <Route path="/uoms" element={<Uom />} />
        <Route path="/manufacturers" element={<Manufactuer />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/products" element={<Product />} />
        <Route path="/products-request" element={<ProductRequest />} />
        <Route path="/delivery-costs" element={<DeliveryCost />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/new/:token" element={<RegisterNewAccount />} />
        <Route path="/pos" element={<Pos />} />
        <Route path="/pos/packages" element={<PosPackages />} />
        <Route path="/pos/packages/:id" element={<PosRegister />} />
        <Route path="/pos-mornitoring" element={<PosMornitoring />} />
        <Route path="/ads" element={<Advertise />} />
        <Route path="/manage-user" element={<ManageUser />} />
        <Route path="/supplier" element={<Suppliers />} />
        <Route path="/purchase" element={<Purchase />} />
        <Route path="/pick-up" element={<Pickup />} />
        <Route path="/grn" element={<GRN />} />
        <Route path="/purchase-setting" element={<PurchaseSetting />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/quotation" element={<Quotation />} />
        <Route path="/point" element={<PointManagement />} />
        <Route path="/tax" element={<TaxManagement />} />
        <Route path="/supplier-order" element={<SupplierOrder />} />
        <Route path="/supplier-invoice" element={<SupplierInvoice />} />
        <Route path="/supplier-billing-note" element={<SupplierBill />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/dashboard-rmx" element={<DashboardRmx />} />
        <Route path="/dashboard-rmx-overall" element={<DashboardRmxOverall />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/order-returns" element={<OrderReturns />} />
        <Route path="/manage-permission" element={<Permissions />} />
        <Route path="/contents" element={<ManageContents />} />
        <Route path="/document-config" element={<DocumentConfig />} />
        <Route path="/point-config" element={<PointConfig />} />
        <Route path="/point-member" element={<PointMember />} />
        <Route path="/point-reward" element={<PointMemberReward />} />
        <Route path="/point-redeem" element={<PointMemberRedeem />} />
        <Route path="/stock-config" element={<StockConfig />} />
        <Route path="/pos-payment-config" element={<PaymentConfig />} />
        <Route path="/permission-denined" element={<PermissionDenied />} />
        <Route element={<PageNotFound />} />
      </Routes>
    )
  }

  if (isMerchant) {
    return getMerchantRoute()
  } else {
    return getStaffRoute()
  }
}

const mapStateToProps = (state: RootState): any => {
  return {
    currentUser: selectCurrentUser(state),
  }
}

const mapDispatchToProps = {}
type DispatchProps = typeof mapDispatchToProps

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(App)
